import React from 'react'
import { Sun, MusicalNote, Loudspeaker, Trophy, Masks, Voucher } from '@ticketswap/comets'
import festivals from './festivals.jpg'
import concerts from './concerts.jpg'
import clubs from './club-nights.jpg'
import sports from './sports.jpg'
import theatre from './theatre-comedy.jpg'
import vouchers from './vouchers-day-out.jpg'
import { color } from '@ticketswap/solar'

export const categories = [
  {
    image: festivals,
    i18nKey: 'common:categories.festivals',
    value: 'FESTIVALS',
    slug: 'festivals',
    icon: <Sun />,
    color: color.sun,
  },
  {
    image: concerts,
    i18nKey: 'common:categories.concerts',
    value: 'CONCERTS',
    slug: 'concerts',
    icon: <MusicalNote />,
    color: color.earth,
  },
  {
    image: clubs,
    i18nKey: 'common:categories.clubs',
    value: 'CLUBS',
    slug: 'clubs',
    icon: <Loudspeaker />,
    color: color.space,
  },
  {
    image: sports,
    i18nKey: 'common:categories.sports',
    value: 'SPORTS',
    slug: 'sports',
    icon: <Trophy />,
    color: color.titan,
  },
  {
    image: theatre,
    i18nKey: 'common:categories.theatre',
    value: 'THEATRE_AND_COMEDY',
    slug: 'theatre-and-comedy',
    icon: <Masks />,
    color: color.mars,
  },
  {
    image: vouchers,
    i18nKey: 'common:categories.vouchers',
    value: 'VOUCHERS_AND_DAY_OUT',
    slug: 'vouchers-and-day-out',
    icon: <Voucher />,
    color: color.spaceMedium,
  },
]

export function getCategories(t) {
  return categories.map(item => ({
    image: item.image,
    name: t(item.i18nKey),
    value: item.value,
    slug: item.slug,
    icon: item.icon,
    color: item.color,
  }))
}
